import { BotNode, BotEvent } from '../types'
import flow from './newFlow'

export const getBotNode = (id: BotEvent):BotNode => {
  const foundNode = flow.find(node => node.id === id)
  if (!foundNode) throw Error('Cannot find bot node by ID')
  return foundNode
}
